import {
  isObject,
  isPlainObject,
  forEach,
  transform,
  isEqual,
  isArray,
} from "lodash-es";

export const deepFreeze = (obj: Object) => {
  Object.freeze(obj);
  Object.keys(obj).forEach(
    (key) =>
      key &&
      isObject(obj[key]) &&
      !Object.isFrozen(obj[key]) &&
      deepFreeze(obj[key])
  );
  return obj;
};

export const jsonToFormData = (data: Object): FormData => {
  const buildFormData = (formData: FormData, data: any, parentKey?: string) => {
    if (
      data &&
      typeof data === "object" &&
      !(data instanceof Date) &&
      !(data instanceof File)
    ) {
      Object.keys(data).forEach((key) => {
        buildFormData(
          formData,
          data[key],
          parentKey ? `${parentKey}[${key}]` : key
        );
      });
    } else if (parentKey) {
      const value = data == null ? "" : data;
      formData.append(parentKey, value);
    }
  };
  const formData = new FormData();
  buildFormData(formData, data);
  return formData;
};

export function plainToFlattenObject(data: Object) {
  const result = {};
  function flatten(obj, prefix = "") {
    forEach(obj, (value, key) => {
      if (isPlainObject(value)) {
        flatten(value, `${prefix}${key}.`);
      } else {
        result[`${prefix}${key}`] = value;
      }
    });
  }
  flatten(data);
  return result;
}

// https://gist.github.com/Yimiprod/7ee176597fef230d1451#gistcomment-2565071
export const difference = (object: Object, base: Object) => {
  return transform(object, (result, value, key) => {
    if (!isEqual(value, base[key])) {
      // @ts-ignore
      result[key] =
        isObject(value) && !isArray(value) && isObject(base[key])
          ? difference(value, base[key])
          : value;
    }
  });
};

/**
 * Creates a new object containing only the specified keys from the source object
 * @param {Object} obj - The source object to pick properties from
 * @param {string[]} keys - Array of key names to include in the result
 * @returns {Object} A new object with only the specified keys
 */
export const pick = (obj: Object, keys: string[]) => {
  return keys.reduce((result, key) => {
    // Check if the key exists in the source object
    if (key in obj) {
      // Add the key-value pair to the result object
      result[key] = obj[key];
    }
    return result;
  }, {}); // Start with an empty object as the initial accumulator
};
